import { Component } from '@theme/component';

class FFCollectionSorting extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.bindSorting();
  }

  updatedCallback() {
    super.updatedCallback();
    this.bindSorting();
  }

  bindSorting() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const details = this.querySelector('details');
    const summary = this.querySelector('summary');
    const links = Array.from(this.querySelectorAll('[data-sort-value]'));
    if (!details || !summary || !links.length) return;
    for (const link of links) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', link.dataset.sortValue);
      url.searchParams.delete('page');
      link.href = url.href;
    }
    summary.setAttribute('aria-expanded', String(details.open));
    details.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(details.open));
    }, { signal });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) details.open = false;
    }, { signal });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) details.open = false;
    }, { signal });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        event.stopPropagation();
        details.open = false;
        summary.focus();
        return;
      }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      details.open = true;
      const index = links.indexOf(document.activeElement);
      const selected = links.find((link) => link.hasAttribute('aria-current'));
      if (document.activeElement === summary && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
        (selected || links[event.key === 'ArrowUp' ? links.length - 1 : 0]).focus();
      } else if (event.key === 'Home') {
        links[0].focus();
      } else if (event.key === 'End') {
        links[links.length - 1].focus();
      } else {
        const step = event.key === 'ArrowDown' ? 1 : -1;
        links[(index + step + links.length) % links.length].focus();
      }
    }, { signal });

    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('[data-sort-value]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      details.open = false;
    }, { signal });
    if (!this.hasAttribute('data-sort-ready')) this.setAttribute('data-sort-ready', '');
  }

  disconnectedCallback() {
    this.controller?.abort();
    super.disconnectedCallback();
  }
}

if (!customElements.get('ff-collection-sorting')) {
  customElements.define('ff-collection-sorting', FFCollectionSorting);
}

